import { DEFAULT_ELEVATION } from "../../../foundations/elevations.es.js";
import { Primary, Text } from "../../../foundations/palette.es.js";
import { Spacing } from "../../../foundations/spacing.es.js";
import { styled } from "@mui/material";
import { styledOptions } from "../../../utils/styled-options/styled-options.es.js";
import Divider from "../../../../node_modules/@mui/material/Divider/Divider.es.js";
import Grid from "../../../../node_modules/@mui/material/Grid/Grid.es.js";
import { Displaying } from "../../../foundations/displaying.es.js";
import { Direction } from "../../../foundations/direction.es.js";
import { Typography } from "../../typography/typography.es.js";
import { Alignment } from "../../../foundations/alignment.es.js";
import { FontWeight } from "../../../foundations/typography.es.js";
const UploaderContainer = styled("div", styledOptions)(({
  elevated
}) => {
  return {
    display: Displaying.flex,
    flexDirection: Direction.column,
    gap: Spacing["750"],
    padding: Spacing["1500"],
    borderRadius: Spacing["750"],
    boxShadow: elevated ? DEFAULT_ELEVATION : "0",
    backgroundColor: Primary.light,
    width: "100%"
  };
});
const TitleTypographyContainer = styled(Typography)({
  display: Displaying.flex,
  padding: "0 !important",
  lineHeight: `${Spacing["2000"]}`,
  color: Text.primary
});
const DividerContainer = styled(Divider, styledOptions)(({
  isMobile
}) => ({
  display: isMobile ? Displaying.none : Displaying.inherit
}));
const GridContainer = styled(Grid, styledOptions)(({
  isMobile
}) => ({
  display: Displaying.flex,
  flexDirection: isMobile ? Direction.column : Direction.row,
  gap: Spacing["750"],
  paddingBottom: isMobile ? Spacing["1500"] : Spacing["0"]
}));
const SupportedFilesTextContainer = styled("div")({
  paddingTop: Spacing["750"],
  display: Displaying.flex,
  justifyContent: Alignment.center,
  gap: Spacing["500"],
  alignItems: Alignment.center
});
const SupportedFilesTypographyContainer = styled(Typography)({
  color: Text.secondary,
  fontSize: Spacing["750"],
  fontStyle: "normal",
  fontWeight: FontWeight.normal,
  lineHeight: "166%",
  letterSpacing: Spacing["25"]
});
const infoIconStyle = {
  width: Spacing["1000"],
  height: Spacing["1000"]
};
export {
  DividerContainer,
  GridContainer,
  SupportedFilesTextContainer,
  SupportedFilesTypographyContainer,
  TitleTypographyContainer,
  UploaderContainer,
  infoIconStyle
};
//# sourceMappingURL=container.es.js.map
